import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
//import { OAuthModule } from 'angular-oauth2-oidc';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { ForgotPasswordPageComponent } from './pages/forgot-password-page/forgot-password-page.component';
import { RegisterPageComponent } from './pages/register-page/register-page.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ForgotPasswordFormComponent } from './forms/forgot-password-form/forgot-password-form.component';
import { NewPasswordFormComponent } from './forms/new-password-form/new-password-form.component';
import { SharedModule } from '../shared/shared.module';
import { RegisterFormComponent } from './forms/register-form/register-form.component';
import { ConfirmRegistrationFormComponent } from './forms/confirm-registration-form/confirm-registration-form.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { ProceedAsGuestModalComponent } from './modals/proceed-as-guest-modal/proceed-as-guest-modal.component';
import { LoginComponent } from './components/login/login.component';
import { LoginDesktopComponent } from './components/login-desktop/login-desktop.component';
import { LoginFormComponent } from './forms/login-form/login-form.component';
import { AuthenticationPageComponent } from './pages/authentication-page/authentication-page.component';
import { AllInOneAuthPageComponent } from './pages/all-in-one-auth-page/all-in-one-auth-page.component';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

@NgModule(
    { 
        declarations: [
            LoginComponent,
            LoginPageComponent,
            ForgotPasswordPageComponent,
            ForgotPasswordFormComponent,
            NewPasswordFormComponent,
            RegisterPageComponent,
            RegisterFormComponent,
            ConfirmRegistrationFormComponent,
            HomePageComponent,
            ProceedAsGuestModalComponent,
            LoginDesktopComponent,
            LoginFormComponent,
            AuthenticationPageComponent,
            AllInOneAuthPageComponent
        ],
        exports: [
            ProceedAsGuestModalComponent,
            AuthenticationPageComponent
        ], 
        imports: [
            CommonModule,
            SharedModule,
            IonicModule,
            FormsModule,
            ReactiveFormsModule,
            //TranslateModule.forChild(),
            AuthRoutingModule,
            //OAuthModule.forRoot()
            MatFormFieldModule,
            MatSelectModule,
        ], 
        providers: [
            provideHttpClient(withInterceptorsFromDi())
        ] 
    })
export class AuthModule { }
